<template>
    <div>
        <modal class="new-bill" :display="modalStatus.newAllBill" @modalStatus="closeModal" >
            <h1>新增帳單</h1>
            <div class="new-bill-wrap" :key="'height'+componentKey" v-bind:style="{'height': modalHeight}">
                <div class="input-wrap">
                    <span>選擇房源</span>
                    <rent-select-house :key="componentKey" :class="{error: error.newBill.choseHouse}" refName="house" :selectMsg="seletcMsg.house" class="select-scroll" @getId="getSelectId" :setDefault="isDefault">
                        <ul>
                            <div class="house-filter">
                                <img class="search" src="@/assets/img/icon/search_gray.svg" alt="">
                                <input v-model="selectHouse" placeholder="搜尋地點、房源名稱" type="text">
                            </div>
                            <li ref="houseItem" @click="$root.$emit('house-item', selectHouseName(index))"  :data-id="item.contractCid" :data-name="item.address" v-for="(item, index) in filterHouse" :key="index">
                                <span class="name" :data-id="item.contractCid" :data-name="item.address" >{{item.name}}</span>
                                <span class="address" :data-id="item.contractCid" :data-name="item.address" >
                                    <img src="@/assets/img/icon/address_gray.svg" alt="">
                                    {{item.address}}
                                </span>
                            </li>
                        </ul>
                    </rent-select-house>
                    <span v-show="error.newBill.choseHouse" class="error">{{error.newBill.choseHouse}}</span>
                </div>
                <div class="input-wrap" >
                    <span>選擇帳單日期</span>
                    <rent-select :key="componentKey"  :class="{error: error.newBill.billPeriodSeq}" refName="period" :selectMsg="seletcMsg.period" @click.native="checkHouse()" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="seletcMsg.isDefault">
                        <ul>
                            <li :data-id="period.billPeriodSeq"  v-for="(period,index) in periodsList" :key="index">
                                {{getFormatDate(period.periodStartDate)}}~{{getFormatDate(period.periodEndDate)}}
                            </li>
                        </ul>
                    </rent-select>
                    <span v-show="error.newBill.billPeriodSeq" class="error">{{error.newBill.billPeriodSeq}}</span>
                </div>
                <div class="input-wrap">
                    <span>帳單名稱</span>
                    <div class="input-error-group">
                        <input :class="{error: error.newBill.billName}" type="text" v-model="newBill.billName" placeholder="例如：第二期 5 月份 ">
                    </div>
                    <span v-show="error.newBill.billName" class="error">{{error.newBill.billName}}</span>
                </div>
                <div class="input-wrap">
                    <span>租金</span>
                    <div class="input-error-group">
                        <input :class="{error: error.newBill.rent}" type="text" v-model="newBill.rent" placeholder="例如：6000" >
                    </div>
                    <span v-show="error.newBill.rent" class="error">{{error.newBill.rent}}</span>
                </div>
                <div class="new-bill-group">
                    <div class="left">
                        <div class="input-wrap">
                            <span>水費</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.waterBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.waterBill" class="error">{{error.newBill.waterBill}}</span>
                        </div>
                        <div class="input-wrap">
                            <span>瓦斯費</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.gasBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.gasBill" class="error">{{error.newBill.gasBill}}</span>
                        </div>
                        <div class="input-wrap">
                            <span>有線電視</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.tvBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.tvBill" class="error">{{error.newBill.tvBill}}</span>
                        </div>
                        <div class="input-wrap">
                            <span>停車費</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.parkingBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.parkingBill" class="error">{{error.newBill.parkingBill}}</span>
                        </div>
                    </div>
                    <div class="right">
                        <div class="input-wrap">
                            <span>電費</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.electricityBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.electricityBill" class="error">{{error.newBill.electricityBill}}</span>
                        </div>
                        <div class="input-wrap">
                            <span>網路費</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.internetBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.internetBill" class="error">{{error.newBill.internetBill}}</span>
                        </div>
                        <div class="input-wrap">
                            <span>清潔費</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.cleaningBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.cleaningBill" class="error">{{error.newBill.cleaningBill}}</span>
                        </div>
                        <div class="input-wrap">
                            <span>管理費</span>
                            <div class="input-error-group">
                                <input type="text" v-model="newBill.managementBill" placeholder="例如：6000">
                            </div>
                            <span v-show="error.newBill.managementBill" class="error">{{error.newBill.managementBill}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-group">
                <button class="default-button confirm" @click="checkInput()">新增</button>
                <button class="border-button reject" @click="closeModal">取消</button>
            </div>
        </modal>
    </div>
</template>
<script>
import Modal from '@/components/widge/Modal.vue';
import RentSelectHouse from '@/components/widge/RentSelectHouse.vue';
import RentSelect from '@/components/widge/RentSelect.vue';
import { mapGetters } from 'vuex'

import { 
    apiGetLeaseDoneTableList,
    apiGetBillPeriods,
    apiInsertBill
    } from "@/apis/api.js"; 

export default {
    data () {
        return {
            modalHeight: (window.innerHeight-300) + 'px',
            componentKey: 0,
            periodsList: [],
            newBill: {
                contractCid: '',
                billPeriodSeq: null,
                billName: '',
                rent: null,
                waterBill: null,
                gasBill: null,
                tvBill: null,
                parkingBill: null,
                electricityBill: null,
                internetBill: null,
                cleaningBill: null,
                managementBill: null
            },
            error: {
                newBill:{
                    choseHouse: '',
                    billPeriodSeq: '',
                    billName: '',
                    rent: '',
                    gasBill: '',
                    tvBill: '',
                    waterBill: '',
                    parkingBill: '',
                    electricityBill: '',
                    internetBill: '',
                    cleaningBill: '',
                    managementBill: ''
                }
            },
            houseName: '請選擇',
            leaseDoneList: [],
            selectHouse: null,
            isDefault: false,
            seletcMsg: {
                house: '請選擇房源',
                period: '選擇帳單日期',
                isDefault: false
            }
        }
    },
    mounted (){
        // this.$analytics.logEvent('新增帳單_所有房源', { screen_name: '新增帳單_所有房源'})
        this.getLeaseDoneList()
        window.addEventListener('resize', this.resizeModal)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeModal)
    },
    watch: {
        newBill: {
            handler: function (val) {
                if(val.contractCid){
                    this.error.newBill.choseHouse = ''
                }
                if(val.billName){
                    this.error.newBill.billName = ''
                }
                if(val.billPeriodSeq){
                    this.error.newBill.billPeriodSeq = ''
                }
                if(val.rent){
                    if(this.checkIsNum(val.rent)){
                        this.error.newBill.rent = ''
                    }else{
                        this.error.newBill.rent = '請填寫數字'
                    }
                }
                if(val.gasBill) {
                    if(this.checkIsNum(val.gasBill)){
                        this.error.newBill.gasBill = ''
                    }else{
                        this.error.newBill.gasBill = '請填寫數字'
                    }
                }
                if(val.tvBill) {
                    if(this.checkIsNum(val.tvBill)){
                        this.error.newBill.tvBill = ''
                    }else{
                        this.error.newBill.tvBill = '請填寫數字'
                    }
                }
                if(val.waterBill) {
                    if(this.checkIsNum(val.waterBill)){
                        this.error.newBill.waterBill = ''
                    }else{
                        this.error.newBill.waterBill = '請填寫數字'
                    }
                }
                if(val.parkinBill) {
                    if(this.checkIsNum(val.parkingBill)){
                        this.error.newBill.parkingBill = ''
                    }else{
                        this.error.newBill.parkingBill = '請填寫數字'
                    }
                }
                if(val.electricityBill) {
                    if(this.checkIsNum(val.electricityBill)){
                        this.error.newBill.electricityBill = ''
                    }else{
                        this.error.newBill.electricityBill = '請填寫數字'
                    }
                }
                if(val.interneBill) {
                    if(this.checkIsNum(val.internetBill)){
                        this.error.newBill.internetBill = ''
                    }else{
                        this.error.newBill.internetBill = '請填寫數字'
                    }
                }
                if(val.cleaningBill) {
                    if(this.checkIsNum(val.cleaningBill)){
                        this.error.newBill.cleaningBill = ''
                    }else{
                        this.error.newBill.cleaningBill = '請填寫數字'
                    }
                }
                if(val.managementBill) {
                    if(this.checkIsNum(val.managementBill)){
                        this.error.newBill.managementBill = ''
                    }else{
                        this.error.newBill.managementBill = '請填寫數字'
                    }
                }
            },
            deep: true
        },
        'newBill.contractCid': function (val) {
            this.getBillPeriods(val)
            this.isDefault = false
        },
        periodsList: function (val) {
            if(val.length == 0){
                this.error.newBill.billPeriodSeq = '無可用帳單'
            }else{
                this.error.newBill.billPeriodSeq = ''
            }
        }
    },
    methods: {
        resizeModal: function (){
            let _self = this
            console.log(window.innerHeight)
            if( window.innerHeight > 610){
                _self.modalHeight = (window.innerHeight-300) + 'px'
                _self.componentKey += 1
            }
        },
        getSelectId: function (value) {
            // console.log(value)
            if( value.ref == 'house' ){
                this.newBill.contractCid = value.id
                this.seletcMsg.isDefault = true
                this.newBill.billPeriodSeq = null
            }else if ( value.ref == 'period' ){
                this.newBill.billPeriodSeq = value.id
                this.seletcMsg.isDefault = false
            }
        },
        addNewBill: function () {
            let data = {
                contractCid: this.newBill.contractCid,
                billPeriodSeq: this.newBill.billPeriodSeq,
                billName: this.newBill.billName,
                rent: this.newBill.rent?this.newBill.rent:0,
                waterBill: this.newBill.waterBill?this.newBill.waterBill:0,
                gasBill: this.newBill.gasBill?this.newBill.gasBill:0,
                tvBill: this.newBill.tvBill?this.newBill.tvBill:0,
                parkingBill: this.newBill.parkingBill?this.newBill.parkingBill:0,
                electricityBill: this.newBill.electricityBill?this.newBill.electricityBill:0,
                internetBill: this.newBill.internetBill?this.newBill.internetBill:0,
                cleaningBill: this.newBill.cleaningBill?this.newBill.cleaningBill:0,
                managementBill: this.newBill.managementBill?this.newBill.managementBill:0
            }
            // console.log(data)
            apiInsertBill(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    this.closeModal()
                }
            })
            .catch(err => {
                // reject(err)
            })
        },
        getBillPeriods: function (cid) {
            let data = cid

            apiGetBillPeriods(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    this.periodsList = res.data.result
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        closeModal: function (type) {
            this.$store.dispatch('setModalStatus', {state: false, type: 'newAllBill'})
            this.newBill = {
                contractCid: '',
                billPeriodSeq: null,
                billName: '',
                rent: null,
                waterBill: null,
                gasBill: null,
                tvBill: null,
                parkingBill: null,
                electricityBill: null,
                internetBill: null,
                cleaningBill: null,
                managementBill: null
            }
            this.error.newBill = {
                    choseHouse: '',
                    billPeriodSeq: '',
                    billName: '',
                    rent: '',
                    gasBill: '',
                    tvBill: '',
                    waterBill: '',
                    parkingBill: '',
                    electricityBill: '',
                    internetBill: '',
                    cleaningBill: '',
                    managementBill: ''
            }
            this.isDefault = true
            this.componentKey += 1
            // if( type == 'newBill' ){
            //     this.modalState.newBill = false
            // }
        },
        getLeaseDoneList: function () {
            apiGetLeaseDoneTableList()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    if( res.data.result.length > 0){
                        this.leaseDoneList = res.data.result
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        selectHouseName: function (index) {
            // console.log(this.$refs.houseItem)
            // console.log(this.$refs.houseItem[index].children[0].innerText)
            // console.log(event)
            return this.$refs.houseItem[index].children[0].innerText
        },
        checkIsNum: function (num) {
            let numerical = /^[0-9]*$/
            return numerical.test(num)?true:false
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date(time);
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            //月及天兩位數
            formatDate[5] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[6] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            if(formatDate[3] - 8 < 0){
                formatDate[3] = 24+(formatDate[3]-8);
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }else{
                formatDate[3] = formatDate[3]-8;
                formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            }
            return formatDate[0]+'-'+formatDate[5]+'-'+formatDate[6];
        },
        checkInput: function () {
            if(!this.newBill.billName){
                this.error.newBill.billName = '請填寫帳單名稱'
            }else{
                this.error.newBill.billName = ''
            }

            if(!this.newBill.rent){
                this.error.newBill.rent = '請填寫金額'
            }else{
                this.error.newBill.rent = ''
            }

            if(!this.newBill.billPeriodSeq){
                this.error.newBill.billPeriodSeq = '請選擇日期'
            }else{
                this.error.newBill.billPeriodSeq = ''
            }

            if(
                this.newBill.billName &&
                this.newBill.rent &&
                this.newBill.billPeriodSeq
            ){
                this.addNewBill()
            }
        },
        checkHouse: function () {
            if(!this.newBill.contractCid){
                this.error.newBill.choseHouse = '請先選擇房源'
            }else{
                this.error.newBill.choseHouse = ''
            }
        }
    },
    computed: {
        filterHouse: function () {
            return this.leaseDoneList.filter((house) => {
                if( this.selectHouse ){
                    if(house.address.includes(this.selectHouse)){
                        return house
                    }
                }else{
                    return house
                }
            });
        },
        ...mapGetters({
            modalStatus: 'GET_MODAL_STATUS',
        })
    },
    components: {
        Modal,
        RentSelectHouse,
        RentSelect
    }
}
</script>
<style lang="scss" scoped>
    #modal.new-bill{
        .error{
            right: 0px;
            top: 7px;
        }
        .modal-content{
            width: 448px;
            padding: 0;
            .detail{
                >h1{
                    margin-top: 32px;
                    margin-bottom: 24px;
                }
                .new-bill-wrap{
                    padding: 0 32px 0 32px;
                    height: 415px;
                    overflow-x: hidden;
                    &::-webkit-scrollbar {
                        display: none;
                    }
                    .input-wrap{
                        position: relative;
                        margin-bottom: 30px;
                        >span{
                            display: block;
                            margin-bottom: 12px;
                        }
                        >.input-error-group{
                            >input{
                                width: 352px;
                            }
                        }
                    }
                    .new-bill-group{
                        display: flex;
                        .left{
                            margin-right: 28px;
                            .input-wrap{
                                >.input-error-group{
                                    >input{
                                        width: 146px;
                                    }
                                }
                            }
                        }
                        .right{
                            .input-wrap{
                                >.input-error-group{
                                    >input{
                                        width: 146px;
                                    }
                                }
                            }
                        }
                    }
                    
                }
            }
            
            .btn-group{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                height: 84px;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                border-radius:  0 0 20px 20px;
                margin: 0 auto;
                button{
                    width: 184px;
                    height: 44px;
                }
                button.confirm{
                    margin-right: 16px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/newAllBill.vue